// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-list {
  border-spacing: 0 0;
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
  cursor: default;
  display: table;
  table-layout: fixed;
  user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  /* IE11: Limit the width of the list to prevent it from growing out of control */
}
@media screen and (min-width: 0\\0 ) {
  .bolt-list {
    max-width: 100vw;
  }
}

.bolt-list.bolt-list {
  border-collapse: separate;
}

.bolt-fixed-height-list-row {
  width: 100%;
}

.bolt-list-row {
  color: inherit;
  display: table-row;
  outline: none;
  text-decoration: none;
  transition: background 80ms linear;
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-list-row {
  transition: none;
}
body.ms-vss-web-vsts-theme-hc-light .bolt-list-row {
  transition: none;
}
.bolt-list-row:hover {
  background-color: rgba(0, 0, 0, .02);
  background-color: var(--component-grid-row-hover-color,rgba(0, 0, 0, .02));
}
.bolt-list-row:hover .bolt-list-cell-content-reveal {
  opacity: 100;
}
@media (forced-colors: active) {
  .bolt-list-row:hover {
    background: Canvas;
    forced-color-adjust: none;
  }
  .bolt-list-row:hover td {
    forced-color-adjust: auto;
  }
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-list-row:hover:not(.bolt-menuitem-divider, .comment-item, .selected) {
  background: rgba(0, 120, 212, 1);
  background: var(--focus-border-color,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-list-row:hover:not(.bolt-menuitem-divider, .comment-item, .selected) {
  background: rgba(0, 120, 212, 1);
  background: var(--focus-border-color,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-list-row:hover .secondary-text {
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-list-row:hover .secondary-text {
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-list-row:hover .list-item-label {
  color: rgba(0, 120, 212, 1);
  color: var(--focus-border-color,rgba(0, 120, 212, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-list-row:hover .list-item-label {
  color: rgba(0, 120, 212, 1);
  color: var(--focus-border-color,rgba(0, 120, 212, 1));
}
.bolt-list-row.focused .bolt-list-cell-content-reveal {
  opacity: 100;
}
@media (forced-colors: active) {
  .bolt-list-row.focused {
    background: Canvas;
    forced-color-adjust: none;
  }
  .bolt-list-row.focused td {
    forced-color-adjust: auto;
  }
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-list-row.focused:not(.comment-item) {
  background: rgba(0, 120, 212, 1);
  background: var(--focus-border-color,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-list-row.focused:not(.comment-item) .secondary-text {
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-list-row.focused:not(.comment-item) {
  background: rgba(0, 120, 212, 1);
  background: var(--focus-border-color,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-list-row.focused:not(.comment-item) .secondary-text {
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
.bolt-list-row.selected {
  background-color: rgba(222, 236, 249, 1);
  background-color: var(--component-grid-selected-row-color,rgba(222, 236, 249, 1));
  outline: none;
}
@media (forced-colors: active) {
  .bolt-list-row.selected {
    background: Canvas;
    forced-color-adjust: none;
  }
  .bolt-list-row.selected td {
    forced-color-adjust: auto;
  }
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-list-row.selected {
  background: transparent;
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-list-row.selected .bolt-list-cell:first-child {
  border-left: 2px solid rgba(0, 120, 212, 1);
  border-left: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-list-row.selected {
  background: transparent;
}
body.ms-vss-web-vsts-theme-hc-light .bolt-list-row.selected .bolt-list-cell:first-child {
  border-left: 2px solid rgba(0, 120, 212, 1);
  border-left: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}
@media (forced-colors: active) {
  .bolt-list-row.selected .bolt-button.bolt-focus-treatment:focus,
  .bolt-list-row.selected .bolt-checkbox.bolt-focus-treatment:focus .bolt-checkmark {
    border-color: Background;
  }
}
.bolt-list-row.selected .bolt-list-cell:first-child {
  border-left: 2px solid rgba(0, 120, 212, 1);
  border-left: 2px solid var(--component-grid-focus-border-color,rgba(0, 120, 212, 1));
}
.bolt-list-row:hover.selected {
  background-color: rgba(222, 236, 249, 1);
  background-color: var(--component-grid-action-selected-cell-hover-color,rgba(222, 236, 249, 1));
}
@media (forced-colors: active) {
  .bolt-list-row:hover.selected {
    background-color: Canvas;
  }
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-list-row:hover.selected {
  background: rgba(0, 120, 212, 1);
  background: var(--focus-border-color,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-list-row:hover.selected {
  background: rgba(0, 120, 212, 1);
  background: var(--focus-border-color,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
.bolt-list-row.single-click-activation {
  cursor: pointer;
}

.bolt-list-row-no-hover:hover {
  background-color: initial;
}

.bolt-list-row-header:hover,
.bolt-list-row-loading:hover {
  background-color: initial;
  cursor: default;
}

.bolt-list-cell {
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
  color: inherit;
  display: table-cell;
  overflow: hidden;
  padding: 0;
  position: relative;
  text-align: left;
  text-decoration: none;
  white-space: nowrap;
}
.bolt-list-cell:first-child {
  border-left: 2px solid transparent;
}
.bolt-list-cell:last-child {
  border-right: 1px solid transparent;
}

.bolt-list-cell-content-reveal {
  opacity: 0;
}

.bolt-list-cell-spacer {
  padding: 0;
}

.bolt-list-cell-text {
  overflow: hidden;
}

.bolt-focus-visible .bolt-list-row:focus .bolt-list-cell {
  border-color: rgba(0, 120, 212, 1);
  border-color: var(--component-grid-focus-border-color,rgba(0, 120, 212, 1));
}

@media (forced-colors: active) {
  .bolt-focus-visible .bolt-list-row:focus .bolt-list-cell {
    background-color: highlight;
  }
}

@media (forced-colors: active) {
  .bolt-focus-visible .bolt-list-row:focus {
    forced-color-adjust: none;
    border-color: highlight;
  }
}
@media screen and (forced-colors: active) and (prefers-color-scheme: light) {
  .bolt-focus-visible .bolt-list-row:focus {
    outline: 3px double highlight;
    outline-offset: 1px;
  }
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-list-row:focus {
    forced-color-adjust: none;
  }
  .bolt-focus-visible .bolt-list-row:focus a {
    forced-color-adjust: auto;
  }
  .bolt-focus-visible .bolt-list-row:focus > td > * {
    forced-color-adjust: auto;
  }
}

.bolt-list-row-marked .bolt-list-cell:first-child {
  border-left:  2px solid;
  border-left-color: rgba( 43, 136, 216 ,  1 );
  border-left-color: rgba( var(--palette-primary-tint-10,43, 136, 216) ,  1 );
}

.bolt-list-overlay-container {
  width: 100%;
}

.bolt-list-cv-optimized .bolt-list-overlay-container {
  isolation: isolate;
}

.bolt-list-overlay {
  pointer-events: none;
  width: 100%;
}
.bolt-list-overlay .bolt-list-drop-additional-indicator {
  background-color: rgba(223, 246, 221, 1);
  background-color: var(--status-success-background,rgba(223, 246, 221, 1));
}

.bolt-list-drag-source-item {
  background-color: rgba(255, 255, 255, 0.40);
  background-color: var(--component-grid-drag-source-color,rgba(255, 255, 255, 0.40));
}

.bolt-drag-image-portal {
  z-index: 100;
}

.bolt-drag-image {
  background-color: rgba(255, 255, 255, 1);
  background-color: var(--callout-background-color,rgba(255, 255, 255, 1));
  height: 40px;
  width: 320px;
  padding: 0px 8px;
}

.bolt-list-cv-optimized .bolt-list-row {
  content-visibility: auto;
  contain-intrinsic-size: auto 32px;
  transition-behavior: allow-discrete;
}

/*# sourceMappingURL=List.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/List/List.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/List/List.css","webpack://./../azure-devops-ui/src/_coreStyles.scss","webpack://./../azure-devops-ui/src/_widgetsCommon.scss"],"names":[],"mappings":"AACA;EACI,mBAAA;EACA,wBC0JW;EDzJX,kDAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;EAEA,yBAAA;EEDF,gFAAgF;AC8F9E;AD5FJ;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EFII,cAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EEFF,kCAAkC;AD0W5B;ACxWR;EACE,gBAAgB;AD0WV;ACxWR;EACE,gBAAgB;AFEd;AEAJ;EACE,oCAAoC;EFE9B,0EAAA;AEAR;AACA;ECGI,YAAA;ADDJ;AACA;EACE;IACE,kBAAkB;IFEV,yBAAA;EEAV;EACA;IACE,yBAAyB;EDqVrB;ACnVR;AACA;EACE,gCAAgC;EDoV1B,0DAAA;EDnVQ,6BGvDK;EHwDL,qDC8FE;AC5FlB;AD6UQ;EDzUQ,gCCwFE;ECzFhB,0DAA0D;ED6UpD,6BAAA;ED5UQ,qDCwFE;ACtFlB;ADuUQ;EDnUQ,6BGpEK;EDmEnB,qDAAqD;ADuU/C;ACrUR;EACE,6BAA6B;EFIvB,qDAAA;AEFR;AACA;EC7BI,2BAAA;EH6BA,qDAAA;AEGJ;AACA;EACE,2BAA2B;EFIjB,qDAAA;AEFZ;AACA;EACE,YAAY;ADqTN;ACnTR;EFMgB;IEJZ,kBAAkB;IFMN,yBAAA;EACI;EEJlB;IDiTM,yBAAA;EDjTQ;AEGhB;AACA;EFDgB,gCAAA;EACI,0DCyDF;ECtDhB,6BAA6B;EFG3B,qDAAA;AEDJ;AACA;EACE,6BAA6B;ECxD3B,qDAAA;AD0DJ;AACA;EACE,gCFCU;EEAV,0DAA0D;EFEhD,6BAAA;EEAV,qDFCc;AEAhB;AACA;ED0RQ,6BAAA;EDtRI,qDAAA;AEDZ;AFGY;EACI,wCAAA;EEDd,iFAAiF;EDuR3E,aAAA;ACrRR;AACA;EFHY;IACI,kBAAA;IEKZ,yBAAyB;EC7EzB;EH4EI;IAAA,yBAAA;EEKN;AACF;AACA;EFAQ,uBAAA;AEER;AACA;EFEI,2CAAA;EACI,qEIjI8B;AFiItC;ACzFI;EHwFA,uBAAA;AEIJ;AACA;EACE,2CAA2C;ED6PrC,qEAAA;AC3PR;AACA;EACE;;IFFU,wBG5IS;EH6IT;AEKZ;AFDI;EACI,2CAAA;EEGN,oFAAoF;AACtF;AFAA;EACI,wCAAA;EEEF,+FAA+F;AACjG;AFAA;EAAA;IAEI,wBAAA;EACA;AEEJ;AACA;EFAA,gCAAA;EACI,0DAAA;EACA,6BAAA;EACA,qDAAA;AEEJ;AACA;EFAI,gCAAA;EACA,0DAAA;EACA,6BAAA;EACA,qDAAA;AEEJ;AACA;EFAI,eAAA;AEEJ;;AFEI;EACI,yBAAA;AECR;;AFGA;;EECE,yBAAyB;EACzB,eAAe;AFEjB;;AECA;EACE,iCAAiC;EFEnC,oCAAA;EACI,cAAA;EEAF,mBAAmB;EACnB,gBAAgB;EFElB,UAAA;EACI,kBIlMiC;EFkMnC,gBAAgB;EAChB,qBAAqB;ECvJnB,mBAAA;ADyJJ;AACA;EACE,kCAAkC;AACpC;AACA;EC7JI,mCAAA;AD+JJ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UC5HM;AD6HR;;AAEA;ECzKI,gBAAA;AD2KJ;;AAEA;EFRQ,kCAAA;EEUN,2EFTU;AEUZ;;AAEA;EACE;IACE,2BAA2B;EAC7B;AFJF;;AEOA;EACE;IFJF,yBAAA;IACI,uBAAA;EEMF;AACF;AFJA;EACI;IEMA,6BAA6B;IAC7B,mBAAmB;EFJvB;AEMA;AACA;EACE;IFJE,yBAAA;EACI;EEMN;IACE,yBAAyB;EFH7B;EACI;IEKA,yBAAyB;EAC3B;AFHF;;AEMA;EACE,uBAAuB;EFHzB,4CAAA;EACI,2ECjEqB;ACsEzB;;AAEA;EACE,WAAW;AACb;;AAEA;EFAI,kBAAA;AEEJ;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,wCAAwC;EACxC,yEAAyE;AAC3E;;AAEA;EACE,2CAA2C;EAC3C,mFAAmF;AACrF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,wEAAwE;EACxE,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA,mCAAmC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
